import {Project, Storage} from "../Utils";
import Carousel from "../../modules/D4D/Components/Carousel";
import CarouselItem from "../../modules/D4D/Components/CarouselItem";
import BYCQuestion from "../../modules/D4D/Components/BYCQuestion";
import ProjectStatus from "../Components/ProjectStatus";
import BYCItem from "../../modules/D4D/Components/BYCItem";

export default {
    components: {Carousel, CarouselItem, question: BYCQuestion, ProjectStatus, item: BYCItem},
    data() {
        const index = this.$route.params.index

        return {
            projectMessages: {},
            image: null,
            project: Storage.getProject(index)
        }
    },
    async mounted() {
        const index = this.$route.params.index

        this.project.forms = Storage.getProjectForms(index)

        Storage.getProjectMessages(this.project.type).forEach((m) => {
            this.projectMessages[m.step + "-" + m.key] = m.value;
        })

        await this.getImage()
    },
    methods: {
        async getImage() {
            if (this.isGuest) {
                const { _, image } = Storage.getProjectImage(this.project.projectId, this.Steps.FORM_SKETCH)
                if (image) this.image = image.image
            } else if (this.isOnline) {
                try {
                    this.image = await Project.getProjectImage(this.project.projectId, this.Steps.FORM_SKETCH)
                } catch (e) {
                    this.image = null
                }
            }
        },
        skip() {

        },
        getMessage(step, key) {
            const message = this.projectMessages[step + "-" + key];
            return message ? message : key;
        },
        printTextOrBlank(text) {
            return !text ? 'blank' : text
        }
    }
}
